/**
 * Tri-state visibility shared by every capability. FULL and HIDDEN are terminal;
 * only PARTIAL obliges a consumer to consult subFeatures (see CapabilityConfig in types.ts).
 */
export enum Visibility {
    FULL = 'FULL',
    HIDDEN = 'HIDDEN',
    PARTIAL = 'PARTIAL'
}
